import React, { useContext, useMemo, useEffect, useRef } from 'react'
import { Formik, Form, Field, FieldArray } from 'formik'
import { ModalBody, ModalFooter, Button } from 'reactstrap'
import capitalize from 'lodash/capitalize'
import * as Yup from 'yup'
import find from 'lodash/find'
import uniqueId from 'lodash/uniqueId'
import {
  transformErrorForForm,
  setNullOnEmptyValues,
  fixInitialValuesNull,
} from '../Form/Fields/utils'
import { ContextFornitori } from '../../apps/PlannerApp/contexts'
import { ConfigPlannerContext } from '../../context'
import { InputField, FileField, DateField, CheckboxField } from '../Form/Fields'
import { PERMISSIONS } from '../../django'
import OrdersSelectAutoComplete from '../OrdersSelectAutoComplete'
import classnames from 'classnames'
import {
  OrdiniFornitoriSameMaterialeState,
  RigheOrdineRivenditaState,
} from '../../apps/PlannerApp/localstate'
import { deps, useRunRj } from 'react-rocketjump'

const INITIAL_FORM_VAULES = {
  fornitore: '',
  tipologia: '',
  stato: 'DA_FARE',
  data_consegna: '',
  note: '',
  testo_email: '',
  testo_pdf: '',
  allegati_data: [],
  domanda1: '',
  domanda2: '',
  domanda3: '',
  rivendita: false,
  riga_ordine: '',
  data_arrivo: '',
  numero_documento: '',
  costo_materiale: '',
  vendita_materiale: '',
  avanzamento_commerciale: false,
}

const OrdineFornitoreSchema = Yup.object().shape({
  note: Yup.string(),
  testo_pdf: Yup.string(),
  testo_email: Yup.string(),
  fornitore: Yup.string().required(),
  tipologia: Yup.string().required(),
  data_consegna: Yup.date(),
  data_ordine: Yup.date(),
  // if stato === 'ARRIVATO' then data_arrivo is required
  data_arrivo: Yup.date().when('stato', {
    is: 'ARRIVATO',
    then: Yup.date().required(
      'La data di consegna effettiva è obbligatoria se lo stato è ARRIVATO'
    ),
    otherwise: Yup.date().nullable(),
  }),
  domanda1_legno: Yup.string().when(['stato', 'tipologia'], {
    is: (stato, tipologia) =>
      stato === 'ARRIVATO' && tipologia === 'legno',
    then: Yup.string().required(
      'La risposta alla domanda 1 è obbligatoria se lo stato è ARRIVATO e la tipologia è legno'
    ),
    otherwise: Yup.string().nullable(),
  }),
  domanda2_legno: Yup.string().when(['stato', 'tipologia'], {
    is: (stato, tipologia) =>
      stato === 'ARRIVATO' && tipologia === 'legno',
    then: Yup.string().required(
      'La risposta alla domanda 2 è obbligatoria se lo stato è ARRIVATO e la tipologia è legno'
    ),
    otherwise: Yup.string().nullable(),
  }),
  numero_documento: Yup.string().when(['domanda2_legno', 'tipologia'], {
    is: (domanda2_legno, tipologia) =>
      (domanda2_legno === 'FSC' || domanda2_legno === 'PEFC') &&
      tipologia === 'legno',
    then: Yup.string().required(
      'Il numero documento è obbligatorio se la domanda 2 è FSC o PEFC e la tipologia è legno'
    ),
    otherwise: Yup.string().nullable(),
  }),
  // if avanzamento_commerciale is true costo_materiale and vendita_materiale are required
  costo_materiale: Yup.number().when('avanzamento_commerciale', {
    is: true,
    then: Yup.number().required(
      'Il costo materiale è obbligatorio se avanzamento commerciale è selezionato'
    ),
    otherwise: Yup.number().nullable(),
  }),
})

function Allegati({ remove, push, form }) {
  return (
    <div>
      <h5>Allegati:</h5>
      {PERMISSIONS.adminOrdiniFornitore && (
        <Button
          onClick={() =>
            push({ file: null, id: uniqueId('local~'), notUploaded: true })
          }
          color="success"
          outline
          size="sm"
          type="button"
        >
          <i className="fas fa-plus"></i>
        </Button>
      )}
      {form.values.allegati_data.map((allegato, i) => (
        <div className="d-flex mt-1 align-items-center" key={allegato.id}>
          {PERMISSIONS.adminOrdiniFornitore && (
            <i
              onClick={() => remove(i)}
              className="fas fa-trash text-danger pointer mr-2"
            ></i>
          )}
          {allegato.notUploaded !== true ? (
            <div>
              <a href={allegato.allegato}>
                {allegato.original_name || 'Allegato'}
              </a>
            </div>
          ) : (
            <Field
              type="file"
              name={`allegati_data[${i}].file`}
              component={FileField}
              className="form-control"
            />
          )}
        </div>
      ))}
    </div>
  )
}

function FormFields({
  fornitori,
  stati,
  tipologia,
  tipologie,
  setFieldValue,
  values,
  orderFornitore,
  showOrder,
  ordine,
  bu,
  sottoconti,
}) {
  const fornitoriForFase = useMemo(
    () => fornitori.filter((f) => f.tipologia === tipologia),
    [fornitori, tipologia]
  )

  const prevTipolgia = useRef(null)
  useEffect(() => {
    if (prevTipolgia.current === null) {
      prevTipolgia.current = tipologia
    } else if (prevTipolgia.current !== tipologia) {
      prevTipolgia.current = tipologia
      setFieldValue('fornitore', '', false)
    }
  }, [tipologia, setFieldValue])

  const [{ data: righeRivendita }] = useRunRj(RigheOrdineRivenditaState, [
    deps.maybeGet(values, 'ordine') ? deps.maybeGet(ordine, 'id') : null,
  ])

  const [{ data: sameOrdiniMateriali }] = useRunRj(
    OrdiniFornitoriSameMaterialeState,
    [
      values.ordine ? values.ordine : null,
      values.tipologia ? values.tipologia : null,
    ]
  )

  console.log('sameOrdiniMateriali', sameOrdiniMateriali)

  return (
    <div className="row">
      {showOrder && (
        <>
          <div className="col-12">
            <label className="mb-0">Ordine</label>
            <OrdersSelectAutoComplete
              value={
                orderFornitore && orderFornitore.ordine_data
                  ? values.ordine_data.id
                  : values.ordine
              }
              hasValue
              debounceTimeout={150}
              isDisabled={orderFornitore}
              loadOptionsOnMenuOpen
              onChange={(ordine) => {
                if (ordine) {
                  console.log('ordine', ordine)
                  setFieldValue('ordine', ordine.id)
                } else {
                  setFieldValue('ordine', '')
                }
              }}
              noOptionsMessage={() => 'Nessun ordine trovato'}
              loadingMessage={() => 'Caricamento ordini...'}
              placeholder={
                orderFornitore && orderFornitore.ordine_data
                  ? 'Seleziona un ordine'
                  : orderFornitore
                  ? 'Nessun ordine associato'
                  : 'Seleziona un ordine'
              }
              isClearable={true}
              name={'ordine'}
              additional={{
                page: 1,
              }}
            />
          </div>
        </>
      )}
      <div
        className={classnames('mt-2 mb-2', {
          'col-6': values.rivendita,
          'col-12': !values.rivendita,
        })}
      >
        <Field
          disabled={!PERMISSIONS.adminOrdiniFornitore}
          label="Extra"
          name="rivendita"
          component={CheckboxField}
          value={values.rivendita}
          onChange={(e) => {
            const isChecked = e.target.checked
            setFieldValue('rivendita', isChecked)
            if (isChecked) {
              setFieldValue('riga_ordine', '')
            } else {
              setFieldValue('riga_ordine', '')
            }
          }}
        />
      </div>
      {values.rivendita && (
        <div className="col-6">
          <Field
            disabled={!PERMISSIONS.adminOrdiniFornitore}
            label="Riga ordine"
            name="riga_ordine"
            component={InputField}
            type="select"
            className="form-control"
          >
            <option value="">--- Scegli riga ordine ---</option>
            {righeRivendita?.map((riga) => (
              <option key={riga.id} value={riga.id}>
                {riga.value}
              </option>
            ))}
          </Field>
        </div>
      )}
      <div className="col-6">
        {tipologie && (
          <Field
            disabled={!PERMISSIONS.adminOrdiniFornitore}
            label="Tipologia"
            type="select"
            name="tipologia"
            component={InputField}
            className="form-control"
          >
            <option value="">{'--- Scegli Tipologia ---'}</option>
            {tipologie.map((tipologia) => (
              <option key={tipologia} value={tipologia}>
                {capitalize(tipologia)}
              </option>
            ))}
          </Field>
        )}
      </div>

      <div className="col-6">
        <Field
          disabled={!PERMISSIONS.adminOrdiniFornitore}
          label="Fornitore"
          type="select"
          name="fornitore"
          component={InputField}
          className="form-control"
        >
          <option value="">{'--- Scegli Fornitore ---'}</option>
          {fornitoriForFase.map((fornitore) => (
            <option key={fornitore.id} value={fornitore.id}>
              {fornitore.nome}
            </option>
          ))}
        </Field>
      </div>
      <div className="col-6">
        <Field
          label="Stato"
          type="select"
          name="stato"
          component={InputField}
          className="form-control"
        >
          <option value=""></option>
          {stati.map((stato) => (
            <option key={stato.nome} value={stato.nome}>
              {stato.nome}
            </option>
          ))}
        </Field>
      </div>
      <div className="col-6">
        <Field
          disabled={!PERMISSIONS.adminOrdiniFornitore}
          label="Valore percentuale"
          type="text"
          name="valore_percentuale"
          component={InputField}
          className="form-control"
        />
        {sameOrdiniMateriali &&
          sameOrdiniMateriali.length > 0 &&
          (values.id
            ? sameOrdiniMateriali.filter((o) => o.id !== values.id).length > 0
            : sameOrdiniMateriali.length > 0) && (
            // exclude current order fornitore if editing
            <div className="alert alert-warning mt-1 text-small">
              <small>
                Attenzione: esistono altri ordini della stessa tipologia
                controlla le percentuali:
              </small>
              <small>
                <ul className="mb-0">
                  {sameOrdiniMateriali
                    .filter((o) => (values.id ? o.id !== values.id : true))
                    .map((o) => (
                      <li key={o.id}>
                        Ordine {o.id} - Fornitore{' '}
                        {o.fornitore_data?.nome || o.fornitore} -{' '}
                        {o.valore_percentuale}%
                      </li>
                    ))}
                </ul>
              </small>
            </div>
          )}
      </div>
      <div className="col-6">
        <Field
          disabled={!PERMISSIONS.adminOrdiniFornitore}
          label="Stato rilievo"
          type="select"
          name="rilievo"
          component={InputField}
          className="form-control"
        >
          <option value=""></option>
          <option value="DA_FARE">DA FARE</option>
          <option value="FATTO">FATTO</option>
        </Field>
      </div>
      <div className="col-6">
        <Field
          disabled={!PERMISSIONS.adminOrdiniFornitore}
          label="Stato co"
          type="select"
          name="co"
          component={InputField}
          className="form-control"
        >
          <option value=""></option>
          <option value="DA_FARE">DA FARE</option>
          <option value="INVIATA">INVIATA</option>
        </Field>
      </div>
      <div className="col-6">
        <Field
          label="Numero documento"
          type="text"
          name="numero_documento"
          component={InputField}
          className="form-control"
        />
      </div>
      <div className="col-6">
        <Field
          disabled={!PERMISSIONS.adminOrdiniFornitore}
          label="Data ordine"
          type="text"
          name="data_ordine"
          component={DateField}
          className="form-control"
        />
      </div>
      <div className="col-6">
        <Field
          label="Data consegna prevista"
          type="text"
          name="data_consegna"
          component={DateField}
          // className="form-control"
        />
      </div>
      <div className="col-6">
        <Field
          label="Data consegna effettiva"
          type="text"
          name="data_arrivo"
          component={DateField}
          // className="form-control"
        />
      </div>
      <div className='col-12'>
        <Field
         label="Avanzamento commerciale"
         name="avanzamento_commerciale"
         component={CheckboxField}
         value={values.avanzamento_commerciale}
        />
      </div>
      <div className="col-6">
        <Field
          label="Costo materiale"
          type="text"
          name="costo_materiale"
          component={InputField}
          className="form-control"
        />
      </div>
      <div className="col-6">
        <Field
          label="Vendita materiale"
          type="text"
          name="vendita_materiale"
          component={InputField}
          className="form-control"
        />
      </div>
      <div className="col-6">
        <Field
          label="Dov'è"
          type="select"
          name="magazzino"
          component={InputField}
          className="form-control"
        >
          <option value=""></option>
          <option value="QR">QR</option>
          <option value="RENIS">RENIS</option>
          <option value="CONSEGNATO AL CLIENTE">CONSEGNATO AL CLIENTE</option>
        </Field>
      </div>
      <div className="col-6">
        <Field
          label="Mittente"
          name="mittente"
          component={InputField}
          className="form-control"
        />
      </div>
      <div className="col-6">
        <Field
          label="Bu"
          type="select"
          name="bu"
          component={InputField}
          className="form-control"
        >
          <option value=""></option>
          {Object.entries(bu).map(([id, nome]) => (
            <option key={id} value={id}>
              {nome}
            </option>
          ))}
        </Field>
      </div>
      <div className="col-6">
        <Field
          label="Sottoconto"
          type="select"
          name="sottoconto"
          component={InputField}
          className="form-select"
        >
          <option value=""></option>
          {Object.entries(sottoconti).map(([id, nome]) => (
            <option key={id} value={id}>
              {nome}
            </option>
          ))}
        </Field>
      </div>
      <div className="col-6">
        <Field
          label="Industriale/Non Industriale"
          type="select"
          name="industriale"
          component={InputField}
          className="form-control"
        >
          <option value=""></option>
          <option value="Industriale">Industriale</option>
          <option value="Non Industriale">Non Industriale</option>
        </Field>
      </div>
      <div className="col-6">
        <Field
          label="Diretto/Indiretto"
          type="select"
          name="diretto"
          component={InputField}
          className="form-control"
        >
          <option value=""></option>
          <option value="Diretto">Diretto</option>
          <option value="Indiretto">Indiretto</option>
        </Field>
      </div>
      <div className="col-6">
        <Field
          label="Cv/CF"
          type="select"
          name="costi"
          component={InputField}
          className="form-control"
        >
          <option value=""></option>
          <option value="CV">Costi Variabili</option>
          <option value="CF">Costi Fissi</option>
        </Field>
      </div>
      <div className="col-6">
        <Field
          label="Numero ddt"
          name="numero_ddt"
          component={InputField}
          className="form-control"
        />
      </div>
      {values.tipologia === 'legno' && (
        <>
          <div className="col-12 mt-2">
            <Field
              label="Il materiale è certificato FSC/ PEFC ?"
              type="select"
              name="domanda1_legno"
              component={InputField}
              // className="form-control"
            >
              <option value=""></option>
              <option value="FSC">FSC</option>
              <option value="PEFC">PEFC</option>
              <option value="Non certificato">Non certificato</option>
            </Field>
          </div>
          <div className="col-12 mt-2">
            <Field
              label="E’ richiesta la certificazione sulla fornitura QR Legno?"
              type="select"
              name="domanda2_legno"
              component={InputField}
              className="form-control"
            >
              <option value=""></option>
              <option value="FSC">FSC</option>
              <option value="PEFC">PEFC</option>
              <option value="CoC non richiesta">CoC non richiesta</option>
            </Field>
          </div>
        </>
      )}
      {values.stato === 'ARRIVATO' &&
        values.data_arrivo &&
        values.tipologia === 'verniciatura' && (
          <>
            <div className="col-12 mt-2">
              <Field
                label="Hai verificato la corrispondenza dei colori dei serramenti rispetto ad un eventuale  campione fatto per il cliente , o alla mazzetta colori dei mordenzati qr legno , o dalla tabella Ral?"
                type="select"
                name="domanda1"
                component={InputField}
                className="form-control"
              >
                <option value=""></option>
                <option value={true}>SI</option>
                <option value={false}>NO</option>
              </Field>
            </div>
            <div className="col-12 mt-2">
              <Field
                label="Hai verificato in caso di bicolore il lato corretto di applicazione rispetto al foglio di verniciatura controfirmato dal verniciatore?"
                type="select"
                name="domanda2"
                component={InputField}
                className="form-control"
              >
                <option value=""></option>
                <option value={true}>SI</option>
                <option value={false}>NO</option>
              </Field>
            </div>
            <div className="col-12 mt-2">
              <Field
                label="Hai verificato la qualità della verniciatura?"
                type="select"
                name="domanda3"
                component={InputField}
                className="form-control"
              >
                <option value=""></option>
                <option value={true}>SI</option>
                <option value={false}>NO</option>
              </Field>
            </div>
          </>
        )}
      <div className="col-12 mt-2">
        <Field
          disabled={!PERMISSIONS.adminOrdiniFornitore}
          label="Note"
          type="textarea"
          rows={3}
          name="note"
          component={InputField}
          className="form-control"
        />
      </div>
      <div className="col-12">
        {((values.ordine && showOrder) || !showOrder) && (
          <Field
            disabled={!PERMISSIONS.adminOrdiniFornitore}
            label="Testo per PDF"
            type="textarea"
            rows={3}
            name="testo_pdf"
            component={InputField}
            className="form-control"
          />
        )}
      </div>
      <div className="col-12">
        {((values.ordine && showOrder) || !showOrder) && (
          <Field
            disabled={!PERMISSIONS.adminOrdiniFornitore}
            label="Testo per email"
            type="textarea"
            rows={3}
            name="testo_email"
            component={InputField}
            className="form-control"
          />
        )}
      </div>
      <div className="col-12">
        {((values.ordine && showOrder) || !showOrder) && (
          <Field
            type="file"
            label={'Immagine pdf'}
            name={`immagine_pdf`}
            component={FileField}
            className="form-control"
          />
        )}
        {((values.ordine && showOrder) || !showOrder) && (
          <>
            {orderFornitore &&
              orderFornitore.id &&
              orderFornitore.immagine_pdf && (
                <Field
                  component={CheckboxField}
                  label="Vuoi eliminare l'immagine pdf?"
                  name="remove_immagine_pdf"
                  className="mb-2"
                />
              )}

            {orderFornitore &&
              orderFornitore.id &&
              orderFornitore.immagine_pdf && (
                <div className="mt-1 mb-1">
                  <img
                    src={orderFornitore.immagine_pdf}
                    width="100"
                    alt="Immagine pdf"
                  />
                </div>
              )}
          </>
        )}
        <FieldArray name="allegati_data" component={Allegati} />
      </div>
    </div>
  )
}

const EMPTY_LIST = []

export default function OrderFornitoreForm({
  save,
  tipologia,
  tipologie,
  orderFornitore,
  toggle,
  inModal = false,
  showOrder = false,
  ordine = null,
}) {
  const fornitori = useContext(ContextFornitori)
  const { valoriStato, buList, sottoconti: sottocontiList } = useContext(ConfigPlannerContext)
  const stati = valoriStato.ordine_fornitore || EMPTY_LIST
  const bu = buList || EMPTY_LIST
  const sottoconti = sottocontiList || EMPTY_LIST

  const initialValues = useMemo(() => {
    if (orderFornitore) {
      return fixInitialValuesNull({
        ...orderFornitore,
        remove_immagine_pdf: false,
      })
    }
    let values = INITIAL_FORM_VAULES

    if (tipologia) {
      const fornitoriForFase = fornitori.filter(
        (f) => f.tipologia === tipologia
      )
      const defaultFornitore = find(fornitoriForFase, { is_default: true })
      if (defaultFornitore) {
        values = { ...values, tipologia, fornitore: defaultFornitore.id }
      } else {
        values = { ...values, tipologia }
      }
    }
    return values
  }, [orderFornitore, tipologia, fornitori])


  return (
    <Formik
      initialValues={initialValues}
      validationSchema={OrdineFornitoreSchema}
      onSubmit={(values, actions) => {
        return save(
          setNullOnEmptyValues({
            ...values,
            domanda1: values.domanda1 === 'true' ? true : false,
            domanda2: values.domanda2 === 'true' ? true : false,
            domanda3: values.domanda3 === 'true' ? true : false,
          })
        ).then(
          () => {
            actions.setSubmitting(false)
          },
          (error) => {
            actions.setSubmitting(false)
            actions.setErrors(transformErrorForForm(error))
          }
        )
      }}
    >
      {({ isSubmitting, values, setFieldValue, errors }) =>
        inModal ? (
          <Form className="p-0 m-0">
            <ModalBody>
              <FormFields
                setFieldValue={setFieldValue}
                fornitori={fornitori}
                showOrder={showOrder}
                tipologie={tipologie}
                tipologia={values.tipologia}
                values={values}
                orderFornitore={orderFornitore}
                fornitore={values.fornitore}
                stati={stati}
                bu={bu}
                sottoconti={sottoconti}
                ordine={ordine}
              />
              {Object.keys(errors).length > 0 && (
                <div className="alert alert-danger mt-2">
                  Ci sono degli errori nel form, controlla i campi evidenziati:
                  <ul className="mb-0">
                    {Object.keys(errors).map((key) => (
                      <li key={key}>{key}</li>
                    ))}
                  </ul>
                </div>
              )}
            </ModalBody>
            <ModalFooter className="justify-content-between">
              <Button disabled={isSubmitting} type="button" onClick={toggle}>
                Annulla
              </Button>
              <Button disabled={isSubmitting} color="success" type="submit">
                Salva
              </Button>
            </ModalFooter>
          </Form>
        ) : (
          <Form>
            <FormFields
              setFieldValue={setFieldValue}
              fornitori={fornitori}
              tipologie={tipologie}
              tipologia={values.tipologia}
              values={values}
              fornitore={values.fornitore}
              showOrder={showOrder}
              orderFornitore={orderFornitore}
              stati={stati}
            />
            <div>
              <Button disabled={isSubmitting} color="success" type="submit">
                Salva
              </Button>
            </div>
          </Form>
        )
      }
    </Formik>
  )
}
